import { Label } from "../../screens/complaint/Complaint.styled";
import { TabContainer } from "../SocialCaseTbas/Social.styled";
import {
  useState,
  FC,
  ReactElement,
  SetStateAction,
  ChangeEvent,
  useRef,
  useEffect,
} from "react";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { ApplyPropertyDetailsProps } from "../move-inRegistrationTabs/interfaces";
import nocsRequestsStore, {
  ChargesResult,
} from "../../stores/NocsRequestsStore";
import General from "../../stores/GeneralStore";
import User from "../../stores/UserStore";
import Error from "../error";
import { ToastContainer } from "react-toastify";
import { Document } from "../Temporary Components/SocialCaseModal.styled";
import errorSubscriptionStore from "src/stores/ErrorSubscriptionStore";
import userStore from "../../stores/UserStore";
import HappyMeterStore from "../../stores/HappyMeter";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { NotifyError } from "../../utils/ShowError";
import { Modal } from "@mui/material";
import InsideModal from "./InsideModal";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import { toJS } from "mobx";
import validateEID from "../../utils/validateEID";
import isValidTenancyDate from "../../utils/validateTenancyDate";
import isEmpty from "../../utils/objectNull";
import ArrowDown from "../../assets/arrowDown.svg";
import trashIcon from "../../assets/trash.svg";
import deviceInfo from "../../utils/deviceInfo";


type RequiredTypesOfNOC =
  | ""
  | "owner"
  | "tenant"
  | "parcel"
  | "plotNOC"
  | "arra"
  | "tenantOut";

type RequiredTypesOfProperty = "" | "Residential" | "Commercial";

interface CustomerAddressResponse {
  areaName: string;
  buildingName: string;
  customerName: string;
  dateOfDelivery: string;
  dateOfDeliverySpecified: boolean;
  deliveryTimeSlot: string;
  flat: string;
  floor: string;
  isSamePremise: boolean;
  landmark: string;
  latitude: string;
  longitude: string;
  mobileNo: string;
  street: string;
}

interface OutsideNOCFormFields {
  nocType: RequiredTypesOfNOC;
  parcelId: string;
  flatNumber: any;
  floorNumber: any;
  buildingName: string;
  personIDType: string;
  personIDNumber: string;
  customerName: string;
  emailAddress: string;
  mobilePhoneNumber: string;
  propertyType: string;
  project: string;
}
interface OptionalFile{
  id: number,
  name: string,
}
const ApplyPropertyDetails: FC<ApplyPropertyDetailsProps> = ({
  onClick,
  insideHead,
  outside,
  setPostNOCDue,
  setFewaValue,
  setParentParcelNumber,
  setParentNocTypeSelected,
  setValue,
  setCaseId,
  fromLogin,
  isTenantExist,
  setTenancyContractExpiryDate,
  setServiceId,

}: ApplyPropertyDetailsProps): ReactElement => {
  const [radio, setRadio] = useState(fromLogin ? 2 : 1);
  const [inside, setInside] = useState<boolean>(fromLogin ? false : true);
  const fewaRef = useRef<HTMLInputElement | null>(null);
  const [isSearchApplied, setIsSearchApplied] = useState(false);
  const [shopNumber, setShopNumber] = useState(false);
  const [floorNumber, setFloorNumber] = useState(false);
  const [parcelId, setParcelId] = useState(false);
  const [buildingName, setBuildingName] = useState(false);
  const [idType, setIdType] = useState(false);
  const [idNumber, setIdNumber] = useState(false);
  const [phoneNumberEr, setPhoneNumberEr] = useState(false);
  const [EmailAddressEr, setEmailAddressEr] = useState(false);
  const [tenantEr, setTenantEr] = useState(false);
  const [propertyTypeEr, setPropertTypeEr] = useState(false);
  const [isParcelValid, setIsParcelValid] = useState(false);
  const [isOrderExist, setNorderExist] = useState(false);
  const [showOwnerExtraFields, setShowOwnerExtraFields] = useState(false);
  const [ownerShipdocErrpr, setOwnerShipdocErrpr] = useState(false);
  const [outsideNetworkExtraFields, setOutsideNetworkExtraFields] =
    useState(false);
  const idNymberRegex: any = /^784-?[0-9]{4}-?[0-9]{7}-?[0-9]{1}$/;
  const parcelIdRegex: any = /^.{8,}$/;
  const phoneNumberRegex: any =
    /^(?:00971|\+971|0)?(?:50|51|52|55|56|58|2|3|4|6|7|9)\d{7}$/;
  const emailAddressRegex: any =
    /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/;
  const [selectTypeOfNOCRequired, setSelectTypeOfNOCRequired] = useState<RequiredTypesOfNOC>(inside ? (isTenantExist != "ownernoc" && isTenantExist != 'tenantnoc') ? "parcel" : "" : "plotNOC");
  const [parcelNumber, setParcelNumber] = useState<string>("");
  const [searchedPremiseId, setSearchedPremiseId] = useState<string>("");
   const tenancyContractExpiryDateValue = useRef<HTMLInputElement | null>(null);

  // response from premise/search API call
  const [premiseDetails, setPremiseDetails] = useState<string>("");
  const [sewerageNumber, setSewerageNumber] = useState<string>("");
  const [customerAddress, SetCustomerAddress] =
    useState<CustomerAddressResponse | null>(null);

  const [uploadedFiles, setUploadedFiles] = useState<any[]>([]);
  const [validationErrors, setValidationErrors] = useState<{
    [key: string]: boolean;
  }>({});
  const [uploadedFilesEr, setUploadedFilesEr] = useState<{
    [key: string]: File;
  }>({});
  // const handleFileEvent = (e: any) => {
  //   if (e.target.files) {
  //     const newFiles = Array.from(e.target.files);
  //     setUploadedFiles([...uploadedFiles, ...newFiles]);
  //   }
  // };
  const [optionalUploadedFiles, setOptionalUploadedFiles] = useState<any>([]);
  const [deviceData, setDeviceData] = useState<any>(null);
  const [tenancyError, setTenancyError] = useState(false);

  useEffect(() => {
    const fetchDeviceInfo = async () => {
      const data = await deviceInfo();
      setDeviceData(data);
    };
    fetchDeviceInfo();
  }, []);

  const handleFileEvent = (
    e: React.ChangeEvent<HTMLInputElement>,
    inputName: any
  ) => {
    const chosenFiles: any = e.target.files;
    setOwnerShipdocErrpr(false)

    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setUploadedFiles([...uploadedFiles, ...newFiles]);
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [inputName]: false,
      }));
      setUploadedFilesEr((prevFiles) => ({
        ...prevFiles,
        [inputName]: chosenFiles[0],
      }));
    }
  };
  const handleRemoveOptionalDocument = (id: number) => {
    setOptionalUploadedFiles((prevFiles: OptionalFile[]) => 
      prevFiles.filter(file => file.id !== id)
    );
  }
  const handleAddOptionalDocument = () => {
    const optionalDocs = [...optionalUploadedFiles];
    const maxId = optionalDocs.length > 0 ? Math.max(...optionalDocs.map(doc => doc.id)) : 0;
    const id = maxId + 1;
    const name = "Optional Attachment (" + id + ")";
    const optionalDoc: OptionalFile = { id, name };
    optionalDocs.push(optionalDoc)
    setOptionalUploadedFiles(optionalDocs);
  }
  const handleAttachMoveIn = async (caseId: any) => {
    const formData = new FormData();
    const data = {
      caseId: caseId,
    };
    formData.append("data", JSON.stringify(data));
    for (let i = 0; i < uploadedFiles.length; i++) {
      formData.append("multiFileUpload", uploadedFiles[i]);
    }
    await nocsRequestsStore.uploadNocDocs({
      errorId: "uploadDocumentsError",
      data: formData,
    });
  };

  const mandatoryDocuments = [
    { key: "makaniCertificate", label: General?.codeLabels['cm_nocownershipdocument']?.label ? General?.codeLabels['cm_nocownershipdocument']?.label : "Ownership Document" },
  ];

  const mandatoryDocumentsForTenant = [
    {
      key: "idProof",
      label: General?.codeLabels['cm_emirates_id_trade']?.label ?
        General?.codeLabels['cm_emirates_id_trade']?.label :
        "Emirates ID/Trade License"
    },
    {
      key: "pretenancyContract",
      label: General?.codeLabels['cm_pre_tenancy']?.label ?
        General?.codeLabels['cm_pre_tenancy']?.label :
        "Pre-tenancy Contract"
    }
  ]

  // for out of network NOC form
  const [outsideNOCFormFields, setOutsideNOCFormFields] =
    useState<OutsideNOCFormFields>({
      nocType: inside ? (isTenantExist != "ownernoc" && isTenantExist != 'tenantnoc') ? "parcel" : "" : "plotNOC",
      parcelId: "",
      flatNumber: null,
      floorNumber: null,
      buildingName: "",
      personIDType: "",
      personIDNumber: "",
      customerName: "",
      emailAddress: "",
      mobilePhoneNumber: "",
      propertyType: "",
      project: "",
    });
  const personIdValues = [
    {
      key: "UNI",
      value: General?.codeLabels['cm_individual']?.label ? General?.codeLabels['cm_individual']?.label : "Emirates ID"
    },
    {
      key: "TDLIC",
      value: General?.codeLabels["cm_mvin_bt_tdlic"]?.label ? General?.codeLabels["cm_mvin_bt_tdlic"]?.label : "Ajman Trade License"
    },
    {
      key: "TDLIC-AN",
      value: General?.codeLabels["cm_mvin_bt_dedappno"]?.label ? General?.codeLabels["cm_mvin_bt_dedappno"]?.label : "Ajman Trade License-Application"
    },
    {
      key: "FZ",
      value: General?.codeLabels["cm_mvin_bt_fztdlic"]?.label ? General?.codeLabels["cm_mvin_bt_fztdlic"]?.label : "Ajman Freezone Trade License"
    },
    {
      key: "MFZ",
      value: General?.codeLabels["cm_mvin_bt_mfztdlic"]?.label ? General?.codeLabels["cm_mvin_bt_mfztdlic"]?.label : "Ajman Media City Freezone Trade License Number"
    },
    {
      key: "OTHRDED",
      value: General?.codeLabels["cm_mvin_bt_othrded"]?.label ? General?.codeLabels["cm_mvin_bt_othrded"]?.label : "Other Emirates Trade License"
    },
  ] as const;
  const propertyTypeValues = [
    {
      key: "Commercial",
      value: General?.codeLabels["cm_nocpropertytypecommercial"]?.label ? General?.codeLabels["cm_nocpropertytypecommercial"]?.label : "Commercial"
    },
    {
      key: "Residential",
      value: General?.codeLabels["cm_nocpropertytyperesidential"]?.label ? General?.codeLabels["cm_nocpropertytyperesidential"]?.label : "Residential"
    },
  ] as const;

  const NOCRequiredTypes = {
    parcel: "parcel",
    owner: "owner",
    tenant: "tenant",
    plotNOC: "OUTP",
    arra: "OUTO",
    tenantOut: "OUTT",
  } as any;



  const validateOutsideNOCFormFields = () => {
    if (selectTypeOfNOCRequired == "plotNOC") {
      return outsideNOCFormFields?.parcelId ? true : false;
    }
    for (let [key, value] of Object.entries(outsideNOCFormFields)) {
      if (value === "") {
        console.log(key);
        return true;
      }
    }
    return true;
  };



  const [showInsideModal, setInsideModal] = useState(false);
  const [validateLoader, setValidateLoader] = useState(false);
  const validateParcel = (pNumber: any) => {
    setValidateLoader(true);
  try{  setIsParcelValid(false);
    var pId;
    nocsRequestsStore
      .validateOutOfNetworkParcel({
        errorId: "validateOutOfNetworkNOCError",
        data: pNumber,
      })
      .then((res) => {
        setIsParcelValid(
          res?.result?.output?.status == "OUTSIDE" ? true : false
        );
       
        pId = res?.result?.output?.status == "OUTSIDE" ? true : false;
        selectTypeOfNOCRequired== "plotNOC" &&
          setShowOwnerExtraFields(
            res?.result?.output?.status == "OUTSIDE" ? true : false
          );
        if (res?.result?.output?.status == "INSIDE") {
          setInsideModal(true);
          setContinueLoader(false);
        }
      });
      setValidateLoader(false);
    return pId;}catch(error:any){
      setValidateLoader(false);
    }
  };

  useEffect(() => { setParcelNumber(""); }, [selectTypeOfNOCRequired]);

  const [searchLoader, setSearchLoader] = useState(false);
  const [continueLoader, setContinueLoader] = useState(false);
  const [nocType, setNocType] = useState<RequiredTypesOfNOC>(inside ? (isTenantExist !== "ownernoc" && isTenantExist !== 'tenantnoc') ? "parcel" : "" : "plotNOC");
  const searchParcel=async()=>{
    try {
      let response = await nocsRequestsStore.premiseSearch({
        errorId: "premiseSearchError",
        data: {
          type: selectTypeOfNOCRequired,
          id: parcelNumber,
        },
      });
      setIsParcelValid(true);
      setPremiseDetails(response.result.premiseDetails);
      setSewerageNumber(response.result.sewerageNo);
      SetCustomerAddress(response.result.customerAddress);
      setSearchedPremiseId(parcelNumber);
      setIsSearchApplied(true);
      setSearchLoader(false);
    } catch (er: any) {
      setPremiseDetails("");
      setIsSearchApplied(false);
      setSearchLoader(false);
    }
  }
  const handleSearch = async () => {
    setSearchLoader(true);
    setIsParcelValid(false);
    if (parcelNumber === "" || selectTypeOfNOCRequired === "") {
      NotifyError(General?.codeLabels["cm_msg_92000_2901"]?.label)

      setIsSearchApplied(false);
      setSearchLoader(false);
      return;
    }
    if(selectTypeOfNOCRequired == "tenant"|| selectTypeOfNOCRequired == "owner"){
      searchParcel();
      return;
    }else{
      let validateInsideNetworkNOC = await nocsRequestsStore.validateInsideNetworkNOC({
        errorId: "validateInsideNetworkNOCError",
        data: parcelNumber,
      })
      if (validateInsideNetworkNOC) {
        if (validateInsideNetworkNOC.result?.output?.status === "OUTSIDE") {
          NotifyError(General?.codeLabels["cm_msg_92000_2901"]?.label)
          setPremiseDetails("");
          setIsSearchApplied(false);
          setSearchLoader(false);
          return;
        } else if (validateInsideNetworkNOC.result?.output?.status === "FAIL") {
          NotifyError(General?.codeLabels['cm_'+validateInsideNetworkNOC.result?.output?.statusMsg?.toLowerCase()]?.label)
          setPremiseDetails("");
          setIsSearchApplied(false);
          setSearchLoader(false);
          return;
        }
      }
      searchParcel();
    }
   
   
  
  };
  const resetValidations = () => {
    setShopNumber(false);
    setFloorNumber(false);
    setBuildingName(false);

    setParcelId(false);
    setIdType(false);
    setIdNumber(false);
    setPhoneNumberEr(false);
    setEmailAddressEr(false);
    setTenantEr(false);
    setPropertTypeEr(false);
    setIsParcelValid(false);
    // setShowOwnerExtraFields(false);
    setOutsideNetworkExtraFields(false);
  };


  const validateIdPlotNoc = async () => {
    setContinueLoader(true);
    const dataWithError = {
      data: { id: personIDNumberRef.current?.value, brand: personIDTypeRef?.current?.value == "FZ" ? "AFZ" : personIDTypeRef?.current?.value },
      errorId: "emirateId",
    };
    if (personIDTypeRef?.current?.value == "UNI") {
      const emirateId = await General.validateEmirateId(dataWithError);
      if (!emirateId?.result) {
        NotifyError(General?.codeLabels["cm_eid_err"]?.label);
        setContinueLoader(false);
        return;
      } else {
        await handleContinueNocOutSide()
      }
    } else if (personIDTypeRef?.current?.value == "FZ") {
      const resp = await General.validateFZ(dataWithError);
      if (
        resp.status === "0" &&
        resp.accountDetails !== null &&
        resp.accountDetails.fZ_Company_Status__c !== "Expired" &&
        await isOnGracePeriod(resp.accountDetails.fZ_License_Expiry_Date__c)
      ) {
        await handleContinueNocOutSide()
      } else {
        setContinueLoader(false);
        NotifyError(General.codeLabels["cm_nodatafound"]?.label)
      }
    } else if (personIDTypeRef?.current?.value == "TDLIC" || personIDTypeRef?.current?.value == "TDLIC-AN") {
      var data;
      personIDTypeRef?.current?.value == "TDLIC" ? data = { licenseNumber: personIDNumberRef.current?.value } : data = { applicationNo: personIDNumberRef.current?.value };
      const resp = await General?.validateAjmanLc({ data, errorId: "emirateId" })
      if (resp.getTransactionInfoResponse && resp.getTransactionInfoResponse.getTransactionInfoResult.newDataSet.transactionStatus) {
        if (await isOnGracePeriod(resp.getTransactionInfoResponse.getTransactionInfoResult.newDataSet.transactionStatus.endDate)) {
          await handleContinueNocOutSide()
        }
        else {
          setContinueLoader(false);
          NotifyError(General?.codeLabels["cm_nodatafound"]?.label)
        }
      } else {
        setContinueLoader(false);
        NotifyError(General?.codeLabels["cm_nodatafound"]?.label)
      }

    } else if (personIDTypeRef?.current?.value == "OTHRDED") {
      await handleContinueNocOutSide()
    }
  };
  const handleContinueNocOutSide = async () => {
    setContinueLoader(true);
    if (!isParcelValid) {
      setContinueLoader(false);
      return;

    }
    // let data = {
    //   ...outsideNOCFormFields,
    //   nocType: NOCRequiredTypes[outsideNOCFormFields.nocType],
    // };
    let data = {
      ...outsideNOCFormFields,
      nocType: NOCRequiredTypes[outsideNOCFormFields.nocType] ? NOCRequiredTypes[outsideNOCFormFields.nocType] : NOCRequiredTypes[inside ? (isTenantExist != "ownernoc" && isTenantExist != 'tenantnoc') ? "parcel" : "" : "plotNOC"],

      personIDType: personIDTypeRef?.current?.value,
      personIDNumber: personIDNumberRef?.current?.value,
      customerName: customerNameRef?.current?.value,
      emailAddress: ownerEmailRef?.current?.value,
      mobilePhoneNumber: ownerMobileRef?.current?.value,

      platform: "Web",
      consentData: {
        deviceVersion: deviceData.device,
        location: deviceData.ip,
        browser: deviceData.platform,
        personId: User.profile.personId||personIDNumberRef?.current?.value,
        fullName:User.profile.name||customerNameRef?.current?.value,
        email:User.profile.email||ownerEmailRef?.current?.value,
        contactNo:User.profile.mobileNumber||ownerMobileRef?.current?.value,
        referenceId: "",
        modeOfConsent: "Out_of_Network"
        }
    };
    // console.log("data1", data);
    if (await validateOutOfNetworkNOC()) {
      let res = await nocsRequestsStore.createOutOfNetworkNOC({
        errorId: "validateOutOfNetworkNOCError",
        data,
      });
      if (res?.message == "Success") {
        setContinueLoader(false);
        setValue(3);
        setCaseId(res?.result?.caseId);
        handleAttachMoveIn(res.result.caseId);
      }
    }
    setContinueLoader(false);
  };

  const handleContinueARRATenant = async (values: any) => {
    setContinueLoader(true);
    const missingMandatoryDocuments = mandatoryDocuments.filter(
      (doc: any) => !uploadedFilesEr[doc.key]
    );

    const missingTenantDocuments = mandatoryDocumentsForTenant.filter(
      (doc: any) => !uploadedFilesEr[doc.key]
    );


    if (selectTypeOfNOCRequired === "tenantOut" && missingTenantDocuments.length > 0) { 
      const newErrors: { [key: string]: boolean } = {};
      missingTenantDocuments.forEach((doc) => {
        newErrors[doc.key] = true;
      });
      setValidationErrors(newErrors);
      setContinueLoader(false);
      return;
    }
    else if (selectTypeOfNOCRequired !== "tenantOut" && missingMandatoryDocuments.length > 0) {
      const newErrors: { [key: string]: boolean } = {};
      missingMandatoryDocuments.forEach((doc) => {
        newErrors[doc.key] = true;
      });
      setValidationErrors(newErrors);
      setContinueLoader(false);
      return;
    }
    let data = {
      parcelId: values.parcelNumber,
      flatNumber: values.flateNumber,
      floorNumber: values.floorNumber,
      buildingName: values.buildingName,
      personIDType: values.personIdType,
      personIDNumber: values.emirate,
      customerName: values.tenantName,
      emailAddress: values.email,
      mobilePhoneNumber: values.mobile,
      propertyType: values.propertyType,
      project: values.project,
      nocType: NOCRequiredTypes[outsideNOCFormFields.nocType] ? NOCRequiredTypes[outsideNOCFormFields.nocType] : NOCRequiredTypes[inside ? (isTenantExist != "ownernoc" && isTenantExist != 'tenantnoc') ? "parcel" : "" : "plotNOC"],
      platform: "Web",
      consentData: {
      deviceVersion: deviceData.device,
      location: deviceData.ip,
      browser: deviceData.platform,
      personId: values.emirate,
      fullName:values.tenantName,
      email:values.email,
      contactNo:values.ownerMobile,
      referenceId: "",
      modeOfConsent: "Out_of_Network"
      }
    };
    // console.log("data2", data);
    let res = await nocsRequestsStore.createOutOfNetworkNOC({
      errorId: "validateOutOfNetworkNOCError",
      data,
    });
    if (res?.message == "Success") {
      setContinueLoader(false);
      setValue(3);
      setCaseId(res?.result?.caseId);
      handleAttachMoveIn(res.result.caseId);
    }
    setContinueLoader(false);
  };
  const handleContinueNocLogedIn = async (e: any) => {
    //This is for Outside network when user is logged in
    setContinueLoader(true);
    if (!inside) {
      await validateIdPlotNoc();
    } else {
      //This is for Inside network when user is logged in
      if (customerAddress) {
        let {
          areaName,
          buildingName,
          customerName,
          dateOfDelivery,
          deliveryTimeSlot,
          flat,
          floor,
          landmark,
          mobileNo,
          street,
          latitude,
          longitude,
          dateOfDeliverySpecified,
          isSamePremise,
        } = customerAddress;

        let data = {
          customerAddress: {
            customerName: customerNameRef?.current?.value,
            mobileNumber: ownerMobileRef?.current?.value,
            areaName,
            floorNo: floor,
            flatNo: flat,
            landmark,
            buildingName,
            latitude,
            longitude,
            dateOfDelivery,
            dateOfDeliverySpecified,
            deliveryTimeSlot,
            street,
          },
          platform:"Web",
          sewerageNo: sewerageNumber,
          fewaRegistrationFlag: fewaRef?.current?.checked ? fewaRef?.current?.checked : false,
          nocType:
            selectTypeOfNOCRequired == "owner"
              ? "owner" 
              : selectTypeOfNOCRequired,
          parcelNo: parcelNumber,
          ...(selectTypeOfNOCRequired === "tenant" && {
            tenancyContractExpiryDate: tenancyContractExpiryDateValue.current?.value
          })
        };
        let response = await nocsRequestsStore.postNocDue({
          errorId: "postNocDueError",
          data,
        });
        setContinueLoader(false);
        setPostNOCDue(response.result);
        onClick && onClick(e);
      }
    }
  };
  const makaniRef = useRef<HTMLInputElement | null>(null);
  const parcelIdRef = useRef<HTMLInputElement | null>(null);
  const flatNumberRef = useRef<HTMLInputElement | null>(null);
  const buildingNameRef = useRef<HTMLInputElement | null>(null);
  const floorNumberRef = useRef<HTMLInputElement | null>(null);
  const personIDTypeRef = useRef<HTMLSelectElement | null>(null);
  const personIDNumberRef = useRef<HTMLInputElement | null>(null);
  const ownerMobileRef = useRef<HTMLInputElement | null>(null);
  const ownerEmailRef = useRef<HTMLInputElement | null>(null);
  const customerNameRef = useRef<HTMLInputElement | null>(null);


  const validateOutOfNetworkNOC = async () => {
    let data = {
      parcelId: parcelIdRef?.current?.value,
      flatNumber: flatNumberRef?.current?.value,
      floorNumber: floorNumberRef?.current?.value,
      buidlingname: buildingNameRef?.current?.value,
      personIDType: personIDTypeRef?.current?.value,
      personIDNumber: personIDNumberRef?.current?.value,
      nocType: NOCRequiredTypes[outsideNOCFormFields.nocType] ? NOCRequiredTypes[outsideNOCFormFields.nocType] : NOCRequiredTypes[inside ? (isTenantExist != "ownernoc" && isTenantExist != 'tenantnoc') ? "parcel" : "" : "plotNOC"],
      IsParcelInside: inside,
    };
    let response = await nocsRequestsStore.validateOutOfNetworkNOC({
      errorId: "validateOutOfNetworkNOCError",
      data,
    });
    return response.result.output.status == "SUCCESS" ? true : false;
  };
  const [sewerageNumberError, setErrSewerageNumber] = useState(false);
  const handleParcelNumberChange = async (e: {
    target: { value: SetStateAction<any> };
  }) => {
    setErrSewerageNumber(false);
    const sanitizedValue = e.target.value.trim()
    const isNumber = !isNaN(Number(sanitizedValue));
    if (!isNumber) {
      setErrSewerageNumber(true);
      return;
    }
    setParcelNumber(e.target.value);
    setParentParcelNumber(e.target.value);
    if (!inside) {
      setOutsideNOCFormFields({
        ...outsideNOCFormFields,
        parcelId: e.target.value.toString(),
      });
    }
  };

  const resetOutsideNOCFields = () => {
    setOutsideNOCFormFields({
      nocType: "",
      parcelId: "",
      flatNumber: "",
      floorNumber: "",
      buildingName: "",
      personIDType: "",
      personIDNumber: "",
      customerName: "",
      emailAddress: "",
      mobilePhoneNumber: "",
      propertyType: "",
      project: "",
    });
  };

  const handleInside = () => {
    setInside(true);
    setRadio(1);

    setSelectTypeOfNOCRequired((isTenantExist != "ownernoc" && isTenantExist != 'tenantnoc') ? "parcel" : "parcel");
    setParentNocTypeSelected("");
    setPremiseDetails("");
    setParcelNumber("");
    setParentParcelNumber("");
    setIsSearchApplied(false);
  };

  const handleOutside = async () => {
    setInside(false);
    setRadio(2);
    setSelectTypeOfNOCRequired("plotNOC");
   
    setParentNocTypeSelected("");
    setParcelNumber("");
    setParentParcelNumber("");
    setPremiseDetails("");
    resetOutsideNOCFields();
    setIsSearchApplied(false);
  };
  const setServicesType = (serviceID: string) => {
    switch (serviceID) {
      case "owner":
        HappyMeterStore.setUPserviceID("3");
        setServiceId("3");

        break;
      case "tenant":
        HappyMeterStore.setUPserviceID("2");
        setServiceId("2");
        break;
      case "parcel":
        HappyMeterStore.setUPserviceID("4");
        setServiceId("4");
        break;
      case "plotNOC":
        console.log("inside plotNOC")
        HappyMeterStore.setUPserviceID("12");
        setServiceId("12");
        break;
      case "arra":
        HappyMeterStore.setUPserviceID("13");
        setServiceId("13");
        break;
      case "tenantOut":
        HappyMeterStore.setUPserviceID("14");
        setServiceId("14");
        break;
      default:
      //
    }
  };
  const handleTypeOfNOCRequiredChange = (
    typeOfNOCRequired: RequiredTypesOfNOC
  ) => {
    localStorage.removeItem("nocType");

    setServicesType(typeOfNOCRequired);
    resetValidations();
    setSelectTypeOfNOCRequired(typeOfNOCRequired);
    if (typeOfNOCRequired != "")
      setParentNocTypeSelected(NOCRequiredTypes[typeOfNOCRequired]);
    if (!inside) {
      setOutsideNOCFormFields({
        ...outsideNOCFormFields,
        nocType: typeOfNOCRequired,
      });
    }
  };
  const handlePersonIdTypeChange = (event: ChangeEvent<HTMLSelectElement>) => {
    setOutsideNOCFormFields({
      ...outsideNOCFormFields,
      personIDType: event.target.value,
    });
  };
  const handlePropertyTypeChange = (event: ChangeEvent<HTMLSelectElement>) => {
    setOutsideNOCFormFields({
      ...outsideNOCFormFields,
      propertyType: event.target.value,
    });
  };
  const [isParcelEmpty, setIsParcelEmpty] = useState(false);

  const handleSearchValidation = () => {
    // Assuming `inside` is a boolean and `parcelNumber` is a string from your state
    if (inside && parcelNumber.trim() !== "") {
      setIsParcelEmpty(true);
      // Proceed with further actions
    } else {
      setIsParcelEmpty(false);
      // Handle the error or prompt the user
    }
  };

  useEffect(() => {
    handleSearchValidation();
  }, [inside, parcelNumber]);

  const isOnGracePeriod = async (endDate: any) => {
    const today = new Date();
    const expiryDate = new Date(endDate);
    const grace: any = await getGracePeriod()
    console.log(toJS(grace))
    const expiryDatenew = new Date(expiryDate.getTime());
    expiryDatenew.setDate(expiryDate.getDate() + grace);
    console.log('Today:', today, "exiryDate:", expiryDatenew)
    return today <= expiryDatenew;
  }
  const getGracePeriod = async () => {
    const res = await General.gracePeriod({ errorId: "gracePeriod" });
    return res?.result?.moveinGracePeriod;
  }
  const validateId = async () => {
    setContinueLoader(true);
    if (personIDTypeRef?.current?.value == "OTHRDED") {
      const res = await validateOutOfNetworkNOC();
      setContinueLoader(false);
      setNorderExist(res);
      setOutsideNetworkExtraFields(res);
      return;
    }

    const dataWithError = {
      data: { id: personIDNumberRef.current?.value, brand: personIDTypeRef?.current?.value == "FZ" ? "AFZ" : personIDTypeRef?.current?.value },
      errorId: "emirateId",
    };
    if (personIDTypeRef?.current?.value == "UNI") {
      if (!validateEID(personIDNumberRef.current?.value)) {
        setContinueLoader(false);
        return
      }
      console.log(dataWithError, 'hh_')
      const emirateId = await General.validateEmirateId(dataWithError);
      if (!emirateId?.result) {
        NotifyError(General?.codeLabels["cm_eid_err"]?.label);
        setContinueLoader(false);
        return;
      } else {
        const res = await validateOutOfNetworkNOC();
        setContinueLoader(false);
        setNorderExist(res);
        setOutsideNetworkExtraFields(res);
      }
    } else if (personIDTypeRef?.current?.value == "FZ" || personIDTypeRef?.current?.value == "MFZ") {
      const resp = await General.validateFZ(dataWithError);
      if (
        resp.status === "0" &&
        resp.accountDetails !== null &&
        resp.accountDetails.fZ_Company_Status__c !== "Expired" &&
        await isOnGracePeriod(resp.accountDetails.fZ_License_Expiry_Date__c)
      ) {
        const res = await validateOutOfNetworkNOC();
        setContinueLoader(false);
        setNorderExist(res);
        setOutsideNetworkExtraFields(res);
      } else {
        setContinueLoader(false);
        NotifyError(General.codeLabels["cm_nodatafound"]?.label)
      }
    } else if (personIDTypeRef?.current?.value == "TDLIC" || personIDTypeRef?.current?.value == "TDLIC-AN") {
      var data;
      personIDTypeRef?.current?.value == "TDLIC" ? data = { licenseNumber: personIDNumberRef.current?.value } : data = { applicationNo: personIDNumberRef.current?.value };
      const resp = await General?.validateAjmanLc({ data, errorId: "emirateId" })
      if (resp.getTransactionInfoResponse && resp.getTransactionInfoResponse.getTransactionInfoResult.newDataSet.transactionStatus) {
        if (await isOnGracePeriod(resp.getTransactionInfoResponse.getTransactionInfoResult.newDataSet.transactionStatus.endDate)) {
          const res = await validateOutOfNetworkNOC();
          setContinueLoader(false);
          setNorderExist(res);
          setOutsideNetworkExtraFields(res);
        }
        else {
          setContinueLoader(false);
          NotifyError(General?.codeLabels["cm_nodatafound"]?.label)
        }
      } else {
        setContinueLoader(false);
        NotifyError(General?.codeLabels["cm_nodatafound"]?.label)
      }

    }
  };
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  const validationSchema = Yup.object().shape({
    parcelNumber: Yup.string()
      .required(General?.codeLabels["cm_nocparcelnumbervalidation"]?.label)
      .matches(/^[0-9]+$/, General?.codeLabels["cm_numbererror"]?.label)
      .min(9, General?.codeLabels["cm_poboxmin"]?.label)
      .max(9, General?.codeLabels["cm_num_max"]?.label),
    mobile: Yup.string()
      .required(General?.codeLabels["cm_pdc_mobilevalidation"]?.label)
      .matches(/^05[0-9]{8}$/, "Invalid mobile number"),
    flateNumber: Yup.string()
      .required(General?.codeLabels["cm_nocflatnovalidation"]?.label)
      .matches(/^[0-9+]+$/, "Flat number can contain only numbers and '+' symbol")
      .max(40, "Flat number cannot exceed 40 characters"),
    floorNumber: Yup.string()
      .required(General?.codeLabels["cm_nocfloornovalidation"]?.label)
      .matches(/^[a-zA-Z0-9]+$/, General?.codeLabels["cm_numbererror"]?.label)
      .notOneOf(["0"],General?.codeLabels["cm_floor_ground_note"]?.label),
    buildingName: Yup.string().required(
      General?.codeLabels["cm_nocbuildingnamevalidation"]?.label
    ).matches(/^[a-zA-Z0-9\u0600-\u06FF\u0900-\u097F ,&/]+$/, General?.codeLabels["cm_invalid_name"]?.label ? General?.codeLabels["cm_invalid_name"]?.label : "Invalid name"),
    tenantName:Yup.string().test(
  "tenant-owner-validation",
  function (value) {
    console.log("state value:", selectTypeOfNOCRequired);

    const isTenantOut =
      typeof selectTypeOfNOCRequired === "string" &&
      selectTypeOfNOCRequired.toLowerCase() === "tenantout";

    if (isTenantOut) {
      if (!value) {
        return this.createError({
          message:
            General?.codeLabels["cm_nocentertenantname"]?.label,
        });
      }
    } else {
      if (!value) {
        return this.createError({
          message: General?.codeLabels["cm_owner_name_required"]?.label,
        });
      }
    }

    return true;
  }
)
    .matches( /^[a-zA-Z0-9\u0600-\u06FF\u0900-\u097F &.\(\)\-\/,@]+$/, General?.codeLabels["cm_invalid_name"]?.label ? General?.codeLabels["cm_invalid_name"]?.label : "Invalid name"),
    project: Yup.string().test('conditional-project', 
      General?.codeLabels["cm_project_name_req"]?.label,
      function(value) {
      if (selectTypeOfNOCRequired === 'arra') {
        return !!value && /^[a-zA-Z\u0600-\u06FF\u0900-\u097F ,&/]+$/.test(value);
      }
      return true;
    }),
    emirate: personIDTypeRef?.current?.value == "UNI"
      ? Yup.string()
        .required(General?.codeLabels["cm_nocpersonidnovalidation"]?.label)
        .min(15, General?.codeLabels["cm_min_15dgts"]?.label)
        .max(15, General?.codeLabels["cm_mob_eidmax"]?.label)
        .matches(/^784[0-9]{12}$/, General?.codeLabels["cm_emirate_req"]?.label ? General?.codeLabels["cm_emirate_req"]?.label : "Emirates ID not valid")
      : Yup.string().required(General?.codeLabels["cm_nocpersonidnovalidation"]?.label),
    email: Yup.string()
      .required(General?.codeLabels["cm_nocenteremailaddress"]?.label)
      .matches(
        /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/,
        General?.codeLabels["cm_emailerr"]?.label
      ),
    personIdType: Yup.string().required(
      General?.codeLabels["cm_reqcm_nocpersonidtypevalidationuirederr"]?.label
    ),
    propertyType: Yup.string().required(
      General?.codeLabels["cm_proptype_rqd"]?.label
    ).matches(/^[a-zA-Z\u0600-\u06FF\u0900-\u097F ,&/]+$/, General?.codeLabels["cm_invalid_name"]?.label ? General?.codeLabels["cm_invalid_name"]?.label : "Invalid name"),
  });
  const validationSchemaOwner = Yup.object().shape({

    ownerMobile: Yup.string()
      .required(General?.codeLabels["cm_pdc_mobilevalidation"]?.label)
      .matches(/^05[0-9]{8}$/, "Invalid mobile number"),
    customerName: Yup.string().required(
      General?.codeLabels["cm_owner_name_required"]?.label
    ).matches( /^[a-zA-Z0-9\u0600-\u06FF\u0900-\u097F &.\(\)\-\/,@]+$/, General?.codeLabels["cm_invalid_name"]?.label ? General?.codeLabels["cm_invalid_name"]?.label : "Invalid name"),
    ownerEmirates: personIDTypeRef?.current?.value == "UNI"
      ? Yup.string()
        .required(General?.codeLabels["cm_nocpersonidnovalidation"]?.label)
        .min(15, General?.codeLabels["cm_min_15dgts"]?.label)
        .max(15, General?.codeLabels["cm_mob_eidmax"]?.label)
        .matches(/^784[0-9]{12}$/, General?.codeLabels["cm_emirate_req"]?.label ? General?.codeLabels["cm_emirate_req"]?.label : "Emirates ID not valid")
      : Yup.string().required(General?.codeLabels["cm_nocpersonidnovalidation"]?.label),
    emailAddress: Yup.string()
      .required(General?.codeLabels["cm_nocenteremailaddress"]?.label)
      .matches(
        /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/,
        General?.codeLabels["cm_emailerr"]?.label
      ),
    personIdType: Yup.string().required(
      General?.codeLabels["cm_nocpersonidtypevalidation"]?.label
    ),
  });

  const initialValues = {
    parcelNumber: "",
    flateNumber: "",
    floorNumber: "",
    buildingName: "",
    personIdType: "",
    emirate: "",
    tenantName: "",
    email: "",
    mobile: "",
    propertyType: "",
    toggle: false,
    project: ""
  };
  const initialValuesOwnerFormik = {
    ownerEmirates: "",
    personIdType: "",
    ownerMobile: "",
    emailAddress: "",
    customerName: "",
    toggle: false
  };
  useEffect(() => {
    // console.log("nocType",selectTypeOfNOCRequired)
    setParcelNumber("");
  }, [selectTypeOfNOCRequired]);
  useEffect(() => {
  // Check if there's an initial value (like "parcel" or "tenant")
  if (selectTypeOfNOCRequired) {
    handleTypeOfNOCRequiredChange(selectTypeOfNOCRequired as RequiredTypesOfNOC);
  }
  // We only want this to run once when the component mounts
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);
  return (
    <>
      <TabContainer
        style={{
          marginTop: "30px",
          display: General?.isLargeScreen ? "grid" : "flex",
          flexDirection: General?.isLargeScreen ? "row" : "column",
        }}
      >
        {!fromLogin && (
          <Label
            style={{
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: `${General.accessibility.fontSize}rem`,
              gap: "0.3rem",
              width: General?.isLargeScreen ? "" : "98%",
              color: contrast?.contrastColor
                ? contrast?.contrastColor
                : ColorAss,
            }}
          >
            {General?.codeLabels["cm_nocnetworktypequestion"]?.label}
            <div
              style={{
                display: "flex",
                width: "50%",
                justifyContent: "space-between",
                fontSize: `${General.accessibility.fontSize}rem`,
              }}
            >
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: "500",
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : ColorAss,
                }}
              >
                <input
                  className="inputColor"
                  style={{ width: "20%", margin: "0" }}
                  type="radio"
                  checked={radio === 1}
                  onChange={handleInside}
                  onClick={insideHead}
                />
                {General?.codeLabels["cm_nocnetworktypeinside"]?.label !==
                undefined
                  ? General?.codeLabels["cm_nocnetworktypeinside"]?.label
                  : "Inside"}
              </label>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: "500",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : ColorAss,
                }}
              >
                <input
                  className="inputColor"
                  style={{ width: "20%" }}
                  type="radio"
                  checked={radio === 2}
                  onChange={handleOutside}
                  onClick={outside}
                />
                {General?.codeLabels["cm_nocnetworktypeoutside"]?.label !==
                undefined
                  ? General?.codeLabels["cm_nocnetworktypeoutside"]?.label
                  : "Outside"}
              </label>
            </div>
          </Label>
        )}
        <Label
          style={{
            color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
            fontFamily: "Segoe UI",
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: `${General.accessibility.fontSize}rem`,
            gap: "0.3rem",
            width: General?.isLargeScreen ? "" : "98%",
          }}
        >
          {General?.codeLabels["cm_type_noc"]?.label
            ? General?.codeLabels["cm_type_noc"]?.label
            : "Select the Type Of NOC Required"}
          {inside ? (
            <select
              style={{
                paddingBottom: "0.2px",
                paddingTop: "0",
                height: "48px",
                paddingLeft: "15px",
                color: contrast?.contrastColor
                  ? contrast?.contrastBackground
                  : ColorAss,
                mixBlendMode: "normal",
                border: "1px solid #B6BFDC",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : "#edf4f6",
              }}
              value={selectTypeOfNOCRequired}
              onChange={(e) => {
                handleTypeOfNOCRequiredChange(
                  e.target.value as RequiredTypesOfNOC
                );
                setContinueLoader(false);
                setShowOwnerExtraFields(false);
              }}
            >
              {isTenantExist == "tenantnoc" ? (
                <option
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastBackground
                      : ColorAss,
                  }}
                  value="tenant"
                >
                  {General?.codeLabels["cm_noctenant"]?.label}
                </option>
              ) : isTenantExist == "ownernoc" ? (
                <option
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastBackground
                      : ColorAss,
                  }}
                  value="owner"
                >
                  {General?.codeLabels["cm_nocowner"]?.label}
                </option>
              ) : (
                <option
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastBackground
                      : ColorAss,
                  }}
                  value="parcel"
                  selected
                >
                  {General?.codeLabels["cm_ascreate_dropdown_plot"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_ascreate_dropdown_plot"]?.label
                    : "Plot you Own"}
                </option>
              )}
              {isTenantExist != "ownernoc" ? (
                <option
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastBackground
                      : ColorAss,
                  }}
                  value="owner"
                >
                  {General?.codeLabels["cm_nocowner"]?.label}
                </option>
              ) : null}
              {isTenantExist != "tenantnoc" ? (
                <option
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastBackground
                      : ColorAss,
                  }}
                  value="tenant"
                >
                  {General?.codeLabels["cm_noctenant"]?.label}
                </option>
              ) : null}
            </select>
          ) : (
            //outside select Noc Type
            <select
              style={{
                paddingBottom: "0.2px",
                paddingTop: "0",
                height: "48px",
                paddingLeft: "15px",
                color: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : ColorAss,
                mixBlendMode: "normal",
                border: "1px solid #B6BFDC",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : "#edf4f6",
                paddingRight: "1rem",
              }}
              value={selectTypeOfNOCRequired}
              onChange={(e) => {
                handleTypeOfNOCRequiredChange(
                  e.target.value as RequiredTypesOfNOC
                );
                setContinueLoader(false);
                setShowOwnerExtraFields(false);
              }}
            >
              <option
                style={{
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastBackground
                    : ColorAss,
                }}
                value=""
                disabled
                selected
                hidden
              >
                {General?.codeLabels["cm_mob_select"]?.label !== undefined
                  ? General?.codeLabels["cm_mob_select"]?.label
                  : "Select"}
              </option>
              <option
                style={{
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastBackground
                    : ColorAss,
                }}
                value="plotNOC"
              >
                {General?.codeLabels["cm_nocoutsideplot"]?.label !== undefined
                  ? General?.codeLabels["cm_nocoutsideplot"]?.label
                  : "Owner - Plot NOC"}
              </option>
              <option
                style={{
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastBackground
                    : ColorAss,
                }}
                value="arra"
              >
                {General?.codeLabels["cm_nocoutsidearra"]?.label !== undefined
                  ? General?.codeLabels["cm_nocoutsidearra"]?.label
                  : "Owner - NOC for a Property (ARRA)"}
              </option>
              <option
                style={{
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastBackground
                    : ColorAss,
                }}
                value="tenantOut"
              >
                {General?.codeLabels["cm_nocoutsidetenant"]?.label !== undefined
                  ? General?.codeLabels["cm_nocoutsidetenant"]?.label
                  : "Tenant"}
              </option>
            </select>
          )}
        </Label>
        {General?.isLargeScreen ? <>&nbsp;</> : null}
        {selectTypeOfNOCRequired == "tenant" ? <p></p> : null}
        {selectTypeOfNOCRequired == "tenant" ? (
          <p
            style={{
              fontWeight: "bold",
              color: "red",
              fontSize: `${General.accessibility.fontSize}rem`,
            }}
          >
            {General?.codeLabels["cm_noc_info_er"]?.label
              ? General?.codeLabels["cm_noc_info_er"]?.label
              : "For Tenancy contract attestation purpose in Ajman Municipality"}
          </p>
        ) : null}
      </TabContainer>
      <hr
        style={{
          border: "1px solid #b6bfdc",
          borderStyle: "none none dotted",
          gridColumn: "1 / span 2",
          width: "100%",
        }}
      />
      {(selectTypeOfNOCRequired == "parcel" ||
        selectTypeOfNOCRequired == "owner" ||
        selectTypeOfNOCRequired == "tenant" ||
        selectTypeOfNOCRequired == "plotNOC") && (
        //only to show one field
        <>
          <Formik
            initialValues={initialValuesOwnerFormik}
            validationSchema={validationSchemaOwner}
            onSubmit={(values, { setSubmitting }) => {
              setOutsideNOCFormFields((prevState) => ({
                ...prevState,
                personIDType: values.personIdType,
                personIDNumber: values.ownerEmirates,
                customerName: values.customerName,
                emailAddress: values.emailAddress,
                mobilePhoneNumber: values.ownerMobile,
              }));
              setTimeout(() => {
                // alert(JSON.stringify(values, null, 2));
                if (isOrderExist) {
                  setFewaValue(
                    fewaRef.current?.checked ? fewaRef.current?.checked : false
                  );
                  // resetValidations()
                  handleContinueARRATenant(values);
                }
                setSubmitting(false);
              }, 400);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              /* and other goodies */
            }) => (
              <form onSubmit={handleSubmit}>
                <TabContainer
                  style={{
                    marginTop: "30px",
                    display: General?.isLargeScreen ? "grid" : "flex",
                    flexDirection: General?.isLargeScreen ? "row" : "column",
                    width: "100%",
                  }}
                >
                  <Label
                    style={{
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : ColorAss,
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      gap: "0.3rem",
                      width: General?.isLargeScreen ? "" : "98%",
                    }}
                  >
                    {selectTypeOfNOCRequired == "owner" ||
                    selectTypeOfNOCRequired == "tenant"
                      ? General?.codeLabels["cm_premiseid"]?.label !== undefined
                        ? General?.codeLabels["cm_premiseid"]?.label
                        : "Sewerage Number"
                      : General?.codeLabels["cm_parcelnumber"]?.label !==
                        undefined
                      ? General?.codeLabels["cm_parcelnumber"]?.label
                      : "Parcel Number"}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: General?.isLargeScreen
                          ? "row"
                          : "column",
                        alignItems: "center",
                        width: "100%",
                        gap: "1rem",
                      }}
                    >
                      <input
                        type="text"
                        // pattern="/'^[0-9]+$/"
                        placeholder={
                          selectTypeOfNOCRequired == "owner" ||
                          selectTypeOfNOCRequired == "tenant"
                            ? General?.codeLabels["cm_entersewno"]?.label !==
                              undefined
                              ? General?.codeLabels["cm_entersewno"]?.label
                              : "Enter Sewerage Number"
                            : General?.codeLabels["cm_nocenterparcelnumber"]
                                ?.label !== undefined
                            ? General?.codeLabels["cm_nocenterparcelnumber"]
                                ?.label
                            : "Enter Parcel Number"
                        }
                        ref={parcelIdRef}
                        style={{
                          color: contrast?.contrastColor
                            ? contrast?.contrastBackground
                            : ColorAss,
                          // height: "46px",
                          background: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "#edf4f6",
                          paddingLeft: "15px",
                          marginBottom: !inside ? "1rem" : "",
                        }}
                        value={parcelNumber}
                        onChange={handleParcelNumberChange}
                        // onBlur={(e) => {
                        //   !inside &&
                        //     !isParcelValid &&
                        //     validateParcel(e.target.value.toString())
                        // }}
                        readOnly={showOwnerExtraFields}
                        minLength={
                          selectTypeOfNOCRequired === "owner" ||
                          selectTypeOfNOCRequired === "tenant"
                            ? 10
                            : 9
                        }
                        maxLength={
                          selectTypeOfNOCRequired === "owner" ||
                          selectTypeOfNOCRequired === "tenant"
                            ? 10
                            : 9
                        }
                      />

                      {inside && (
                        <ButtonSecondary
                          style={{
                            width: General?.isLargeScreen ? "179px" : "100%",
                            height: "50px",

                            padding: "10px 0",
                            fontSize: `${General.accessibility.fontSize}rem`,
                            color: contrast?.contrastBackground
                              ? contrast?.contrastBackground
                              : "#fff",
                            background: contrast?.contrastColor
                              ? contrast?.contrastColor
                              : ColorAss,
                            opacity: !isParcelEmpty ? "0.5" : "1",
                            border: "none",
                          }}
                          disabled={!isParcelEmpty}
                          onClick={handleSearch}
                        >
                          {searchLoader ? (
                            <Spinner width="30px" height="30px" />
                          ) : General?.codeLabels["cm_search"]?.label !==
                            undefined ? (
                            General?.codeLabels["cm_search"]?.label
                          ) : (
                            "Search"
                          )}
                        </ButtonSecondary>
                      )}
                    </div>
                  </Label>

                  <Label
                    style={{
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : ColorAss,
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      gap: "0.3rem",
                      width: General?.isLargeScreen ? "" : "98%",
                    }}
                  >
                    {isSearchApplied && inside && (
                      <>
                        <span
                          style={{
                            fontWeight: "700",
                            fontSize: `${General.accessibility.fontSize}rem`,
                            color: contrast?.contrastColor
                              ? contrast?.contrastColor
                              : ColorAss,
                          }}
                        >
                          {General?.codeLabels["cm_propertydet"]?.label !==
                          undefined
                            ? General?.codeLabels["cm_propertydet"]?.label
                            : "Property Details"}
                        </span>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: General?.isLargeScreen
                              ? "row"
                              : "column",
                            alignItems: General?.isLargeScreen ? "center" : "",
                            width: "100%",
                            gap: "1rem",
                          }}
                        >
                          <span
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-evenly",
                            }}
                          >
                            <span
                              style={{
                                fontSize: `${General.accessibility.fontSize}rem`,
                                color: contrast?.contrastColor
                                  ? contrast?.contrastColor
                                  : ColorAss,
                              }}
                            >
                              {premiseDetails}
                            </span>
                          </span>
                        </div>
                      </>
                    )}
                  </Label>

                  {(selectTypeOfNOCRequired == "parcel" ||
                    selectTypeOfNOCRequired == "owner") && (
                    <>
                      <Label>
                        <div style={{ display: "flex" }}>
                          <input
                            className="inputRadio1"
                            type="checkBox"
                            defaultChecked={true}
                            ref={fewaRef}
                            style={{
                              accentColor: "#62AA51",
                              background: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : "",
                              color: contrast?.contrastBackground
                                ? contrast?.contrastBackground
                                : "",
                              width: "15px",
                            }}
                          />
                          <p
                            style={{
                              color: contrast?.contrastColor
                                ? contrast?.contrastColor
                                : ColorAss,
                              marginTop: "1rem",
                              marginLeft: "0.5rem",
                            }}
                          >
                            {General?.codeLabels["cm_fewa"]?.label !== undefined
                              ? General?.codeLabels["cm_fewa"]?.label
                              : "fewa"}
                          </p>
                        </div>
                      </Label>
                    </>
                  )}

                  {showOwnerExtraFields && (
                    <>
                      <Label
                        style={{
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : ColorAss,
                          fontFamily: "Segoe UI",
                          fontStyle: "normal",
                          fontWeight: "700",
                          fontSize: `${General.accessibility.fontSize}rem`,
                          gap: "0.3rem",
                          width: General?.isLargeScreen ? "" : "98%",
                        }}
                      >
                        {General?.codeLabels["cm_ownername"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_ownername"]?.label
                          : "Owner Name"}
                        *{" "}
                        <Field
                          innerRef={customerNameRef}
                          type="text"
                          placeholder={
                            General?.codeLabels["cm_type_here"]?.label
                              ? General?.codeLabels["cm_type_here"]?.label
                              : "Type Here"
                          }
                          style={{
                            background: "#edf4f6",
                            paddingLeft: "15px",
                          }}
                          name="customerName"
                        />
                        <div style={{ height: "0.5rem" }}>
                          <ErrorMessage
                            name="customerName"
                            component="div"
                            className="error-message"
                          />
                        </div>
                      </Label>
                      <Label
                        style={{
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : ColorAss,
                          fontFamily: "Segoe UI",
                          fontStyle: "normal",
                          fontWeight: "700",
                          fontSize: `${General.accessibility.fontSize}rem`,
                          gap: "0.3rem",
                          width: General?.isLargeScreen ? "" : "98%",
                        }}
                      >
                        {General?.codeLabels["cm_mob_email"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_mob_email"]?.label
                          : "Email Address"}
                        *{" "}
                        <Field
                          className="blueInput"
                          type="email"
                          innerRef={ownerEmailRef}
                          placeholder={
                            General?.codeLabels["cm_type_here"]?.label
                              ? General?.codeLabels["cm_type_here"]?.label
                              : "Type Here"
                          }
                          style={{
                            background: "#edf4f6",
                            paddingLeft: "15px",
                          }}
                          name="emailAddress"
                        />
                        <div style={{ height: "0.5rem" }}>
                          <ErrorMessage
                            name="emailAddress"
                            component="div"
                            className="error-message"
                          />
                        </div>
                      </Label>
                      <Label
                        style={{
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "",
                          fontFamily: "Segoe UI",
                          fontStyle: "normal",
                          fontWeight: "700",
                          fontSize: `${General.accessibility.fontSize}rem`,
                          gap: "0.3rem",
                          width: General?.isLargeScreen ? "" : "98%",
                        }}
                      >
                        {General?.codeLabels["cm_mobilenumber"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_mobilenumber"]?.label
                          : "Mobile Number*(05X-Xxx-Xxxx)"}
                        <Field
                          className="blueInput"
                          type="tel"
                          innerRef={ownerMobileRef}
                          name="ownerMobile"
                          placeholder={
                            General?.codeLabels["cm_mobilenumber"]?.label !==
                            undefined
                              ? General?.codeLabels["cm_mobilenumber"]?.label
                              : "Mobile Number*(05X-Xxx-Xxxx)"
                          }
                          style={{ background: "#edf4f6", paddingLeft: "15px" }}
                        />
                        <div style={{ height: "0.5rem" }}>
                          <ErrorMessage
                            name="ownerMobile"
                            component="div"
                            className="error-message"
                          />
                        </div>
                      </Label>
                      <Label
                        style={{
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "",
                          fontFamily: "Segoe UI",
                          fontStyle: "normal",
                          fontWeight: "700",
                          fontSize: `${General.accessibility.fontSize}rem`,
                          gap: "0.3rem",
                          width: General?.isLargeScreen ? "" : "98%",
                        }}
                      >
                        {General?.codeLabels["cm_onocpersonidtype"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_onocpersonidtype"]?.label
                          : "Person ID Type"}
                        *{" "}
                        <Field
                          as="select"
                          style={{ paddingLeft: "15px", color: "#101E8E" }}
                          // value={outsideNOCFormFields.personIDType}
                          // onChange={handlePersonIdTypeChange}
                          disabled={outsideNetworkExtraFields}
                          innerRef={personIDTypeRef}
                          name="personIdType"
                          className="SocialCaseSelect"
                        >
                          <option
                            style={{
                              fontSize: `${General.accessibility.fontSize}rem`,
                            }}
                            value=""
                            disabled
                            selected
                            hidden
                          >
                            {General?.codeLabels["cm_mob_select"]?.label !==
                            undefined
                              ? General?.codeLabels["cm_mob_select"]?.label
                              : "Select"}
                          </option>
                          {personIdValues.map((personId) => (
                            <option
                              style={{
                                fontSize: `${General.accessibility.fontSize}rem`,
                              }}
                              value={personId.key}
                            >
                              {personId.value}
                            </option>
                          ))}
                        </Field>
                        <div style={{ height: "0.5rem" }}>
                          <ErrorMessage
                            name="personIdType"
                            component="div"
                            className="error-message"
                          />
                        </div>
                      </Label>
                      <Label
                        style={{
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "",
                          fontFamily: "Segoe UI",
                          fontStyle: "normal",
                          fontWeight: "700",
                          fontSize: `${General.accessibility.fontSize}rem`,
                          gap: "0.3rem",
                          width: General?.isLargeScreen ? "" : "98%",
                        }}
                      >
                        {General?.codeLabels["cm_onocpersonidno"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_onocpersonidno"]?.label
                          : "ID Number"}
                        *{" "}
                        <Field
                          className="blueInput"
                          type="number"
                          placeholder={
                            General?.codeLabels["cm_type_here"]?.label
                              ? General?.codeLabels["cm_type_here"]?.label
                              : "Type Here"
                          }
                          style={{ background: "#edf4f6", paddingLeft: "15px" }}
                          // value={outsideNOCFormFields.personIDNumber}
                          readOnly={outsideNetworkExtraFields}
                          name="ownerEmirates"
                          innerRef={personIDNumberRef}

                          // onChange={(e) => {
                          //   setOutsideNOCFormFields({
                          //     ...outsideNOCFormFields,
                          //     personIDNumber: e.target.value.toString(),
                          //   });
                          // }}
                        />
                        <div style={{ height: "0.5rem" }}>
                          <ErrorMessage
                            name="ownerEmirates"
                            component="div"
                            className="error-message"
                          />
                        </div>
                      </Label>
                      <Label
                        style={{
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "",
                          fontFamily: "Segoe UI",
                          fontStyle: "normal",
                          fontWeight: "700",
                          fontSize: `${General.accessibility.fontSize}rem`,
                          lineHeight: "16px",
                          gap: "0.5rem",
                          width: "100%",
                        }}
                      >
                        {General?.codeLabels["cm_nocownershipdocument"]
                          ?.label !== undefined
                          ? General?.codeLabels["cm_nocownershipdocument"]
                              ?.label
                          : "Ownership Document"}
                        *
                        <Document
                          exists={false}
                          subText={
                            General?.codeLabels["cm_nocmandatoryattachments"]
                              .label
                          }
                          mainText={
                            General?.codeLabels["cm_nocownershipdocument"].label
                          }
                          onChange={(e: any) =>
                            handleFileEvent(e, "emiratesIdFile")
                          }
                          inputName={"emiratesIDFile"}
                        />
                        {ownerShipdocErrpr && (
                          <p
                            style={{
                              color: "red",
                              margin: "4px 0 0 0",
                              fontWeight: "bold",
                            }}
                          >
                            {General?.codeLabels["cm_nofileerr"]?.label
                              ? General?.codeLabels["cm_nofileerr"]?.label
                              : "Please uploadType Here"}{" "}
                            {
                              General?.codeLabels["cm_nocownershipdocument"]
                                .label
                            }
                          </p>
                        )}
                      </Label>

                      <div
                    style={{
                      border: `1px solid ${ contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : ""}`,
                      textAlign: "center",
                      cursor: "pointer",
                      display: "inline-block",
                      height: "25px",
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: "14px",
                      lineHeight: "20px",
                      textTransform: "uppercase",
                      background: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : "",
                      width: General?.isLargeScreen ? "210px" : "100%",
                    }}
                    onClick={handleAddOptionalDocument}
                  >
                    {General?.codeLabels["cm_add_attachment"]?.label !==
                    undefined
                      ? General?.codeLabels["cm_add_attachment"]?.label
                      : "Add Document"}
                  </div>

                      <Label></Label>
                      {optionalUploadedFiles.map(
                        (optionalFile: OptionalFile) => (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ width: "100%" }}>
                              <Document
                                exists={false}
                                mainText={optionalFile.name}
                                subText={
                                  General?.codeLabels["cm_optional_document"]
                                    ?.label !== undefined
                                    ? General?.codeLabels[
                                        "cm_optional_document"
                                      ]?.label
                                    : "Optional Document"
                                }
                                onChange={(e) =>
                                  handleFileEvent(e, optionalFile.id)
                                }
                                inputName={optionalFile.name}
                                removeButton={
                                  <button
                                    type="button"
                                    style={{
                                      cursor: "pointer",
                                      background: "none",
                                      border: 0,
                                      // marginLeft: "8px",
                                    }}
                                    onClick={() => handleRemoveOptionalDocument(optionalFile.id)}
                                  >
                                    <img src={trashIcon} alt="Remove Optional Attachment" />
                                  </button>
                                }
                              />
                            </div>
                            {/* <div>
                              <button
                                type="button"
                                style={{
                                  cursor: "pointer",
                                  background: "none",
                                  border: 0,
                                }}
                                onClick={() =>
                                  handleRemoveOptionalDocument(optionalFile.id)
                                }
                              >
                                <img
                                  src={trashIcon}
                                  alt="Remove Optional Attachment"
                                />
                              </button>
                            </div> */}
                          </div>
                        )
                      )}
                    </>
                  )}
                   {selectTypeOfNOCRequired === "tenant" && isSearchApplied && (
                      <Label
                      style={{
                        color: General.contrast.contrastColor
                          ? General.contrast.contrastColor
                          : General?.ColorAss,
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        lineHeight: "16px",
                        gap: "0.5rem",
                      }}
                    >
                      {General?.codeLabels["cm_tenancy_contract"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_tenancy_contract"]?.label
                        : "Tenancy / Contract Expiry Date*"}
                      *
                      <Field
                        name="tenancyDate"
                        min={new Date().toISOString().split("T")[0]}
                        innerRef={tenancyContractExpiryDateValue}
                        onChange={(e:any) => {
                              if (e.target.value) {
                                setTenancyError(false);
                      }
                        }}
                        type="date"
                        // defaultValue={defaultDateContract}
                        placeholder="dd-mm-yyyy"
                        style={{
                          background: General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : "#E5EFF2",
                          color: General.contrast.contrastBackground
                            ? General.contrast.contrastBackground
                            : General?.ColorAss,
                        }}
                      />
                      <div style={{ height: "0.5rem" }}>
                       {tenancyError && (
                            <div className="error-message">
                                {General?.codeLabels["cm_mob_contexpdterr"]?.label ||
                                "Tenancy / Contract Expiry Date is required"}
                            </div>
                       )}
                      </div>
                    </Label>
                  )}
                  <hr
                    style={{
                      gridColumn: "1 / span 2",
                      width: "100%",
                      border: "1px solid #B6BFDC;",
                    }}
                  />

                
                    {(inside)&&<ButtonSecondary
                      style={{
                        color: contrast?.contrastBackground
                          ? contrast?.contrastBackground
                          : "#fff",
                        background: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : ColorAss,
                        width: General?.isLargeScreen ? "60%" : "98%",
                        padding: "10px 0",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        opacity:
                          (!showOwnerExtraFields && !inside) || !isParcelValid||(inside &&
                                       selectTypeOfNOCRequired === "tenant" &&
                                       isSearchApplied &&
                                       tenancyError)
                            ? "0.5"
                            : "1",
                        border: "none",
                      }}
                      disabled={(!isSearchApplied && inside) || !isParcelValid ||(inside &&
                                       selectTypeOfNOCRequired === "tenant" &&
                                       isSearchApplied &&
                                       tenancyError)}
                      onClick={(e) => {
                        // handleContinue(e);
                        const tenancyDateValue = tenancyContractExpiryDateValue.current?.value;
                        setTenancyContractExpiryDate(tenancyDateValue);
                        setFewaValue(
                          fewaRef.current?.checked
                            ? fewaRef.current?.checked
                            : false
                        );
                        if (!inside) {
                          if (uploadedFiles?.length < 1) {
                            setOwnerShipdocErrpr(true);
                            return;
                          }
                          if (!isEmpty(errors)) {
                            return;
                          }
                          if (personIDTypeRef?.current?.value == "UNI") {
                            if (
                              !validateEID(personIDNumberRef?.current?.value)
                            ) {
                              return;
                            }
                          }
                        }
                        if (
                          inside &&
                          selectTypeOfNOCRequired === "tenant" &&
                          isSearchApplied &&
                          !isValidTenancyDate(tenancyDateValue)
                         ) {
                         setTenancyError(true);
                          return;
                         }

                        resetValidations();
                        if (!fromLogin) {
                          handleContinueNocLogedIn(e);
                        } else {
                          validateIdPlotNoc();
                        }
                      }}
                    >
                      {continueLoader ? (
                        <Spinner width="30px" height="30px" />
                      ) : isOrderExist ? (
                        General?.codeLabels["cm_btncontinue"]?.label
                      ) : General?.codeLabels["cm_btncontinue"]?.label !==
                        undefined ? (
                        General?.codeLabels["cm_btncontinue"]?.label
                      ) : (
                        "CONTINUE"
                      )}
                    </ButtonSecondary>
                    
                  }
               
                  {(!inside && showOwnerExtraFields) && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                      <div
                     style={{
                       display: "flex",
                       flexDirection: "column",
                       gap: "0.5rem",
                          marginBottom: "",
                          
                          width: "100%",
                       position: "relative",
                     }}
                   >
                       <div
                       style={{
                         display: "flex",
                         alignItems: "flex-start", // Changed from center to flex-start
                            gap: "0.5rem",
                            position: "absolute",
                         width:"1000px"
                       }}
                       >
                       <Field
                         style={{ 
                        //  width: "20px", 
                         height: "20px",
                         marginTop: "3px" // Added marginTop to align with text
                         }}
                         name="toggle"
                         type="checkbox"
                       />
                         <label
                         style={{
                         fontFamily: "Segoe UI",
                         fontStyle: "normal",
                         fontWeight: "400",
                         fontSize: `${General.accessibility.fontSize}rem`,
                         lineHeight: "20px",
                         paddingTop:"2px",
                         color: General.contrast.contrastColor
                           ? General.contrast.contrastColor
                           : General?.ColorAss,
                            }}
                            
                         >
                            <span style={{letterSpacing:"-0.5px"}} dangerouslySetInnerHTML={{
                         __html: (General?.codeLabels["cm_user_consent_msg"]?.label !== undefined
                           ? General?.codeLabels["cm_user_consent_msg"]?.label 
                           : "I accept all")
                         }} />
                         </label>
                       </div>
                     {/* <hr style={{ width: "100%" }} /> */}
                     </div>

                    <ButtonSecondary
                      style={{
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : "#fff",
                      background: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : ColorAss,
                      width: General?.isLargeScreen ? "60%" : "98%",
                      padding: "10px 0",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      opacity:
                        (!showOwnerExtraFields && !inside) || !isParcelValid || !values.toggle
                        ? "0.5"
                        : "1",
                          border: "none",
                          marginTop:"3rem"

                      }}
                      disabled={(!isSearchApplied && inside) || !isParcelValid || !values.toggle}
                      onClick={(e) => {
                        // handleContinue(e);
                        setFewaValue(
                          fewaRef.current?.checked
                            ? fewaRef.current?.checked
                            : false
                        );
                        if (!inside) {
                          if (uploadedFiles?.length < 1) {
                            setOwnerShipdocErrpr(true);
                            return;
                          }
                          if (!isEmpty(errors)) {
                            return;
                          }
                          if (personIDTypeRef?.current?.value == "UNI") {
                            if (
                              !validateEID(personIDNumberRef?.current?.value)
                            ) {
                              return;
                            }
                          }
                        }
                        resetValidations();
                        if (!fromLogin) {
                          handleContinueNocLogedIn(e);
                        } else {
                          validateIdPlotNoc();
                        }
                      }}
                    >
                      {continueLoader ? (
                        <Spinner width="30px" height="30px" />
                      ) : isOrderExist ? (
                        General?.codeLabels["cm_btncontinue"]?.label
                      ) : General?.codeLabels["cm_btncontinue"]?.label !==
                        undefined ? (
                        General?.codeLabels["cm_btncontinue"]?.label
                      ) : (
                        "CONTINUE"
                      )}
                    </ButtonSecondary>
                   </div> 
                    )}
                    
                    {!showOwnerExtraFields && !inside && <ButtonSecondary
                      style={{
                        color: contrast?.contrastBackground
                          ? contrast?.contrastBackground
                          : "#fff",
                        background: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : ColorAss,
                        width: General?.isLargeScreen ? "60%" : "98%",
                        padding: "10px 0",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        border: "none",
                        opacity: !parcelIdRef?.current?.value ? "0.5" : "1",
                      }}
                      disabled={!parcelIdRef?.current?.value}
                      onClick={(e) => {
                        const parcelNumber = parcelIdRef?.current?.value;
                        !inside && validateParcel(parcelNumber?.toString());
                      }}
                      type="button"
                    >
                      {validateLoader ? (
                        <Spinner width="30px" height="30px" />
                      ) : General?.codeLabels["cm_btncontinue"]?.label !==
                        undefined ? (
                        General?.codeLabels["cm_btncontinue"]?.label
                      ) : (
                        "CONTINUE"
                      )}
                    </ButtonSecondary>}
             
                     
                </TabContainer>
              </form>
            )}
          </Formik>
        </>
      )}

      {!inside &&
        selectTypeOfNOCRequired != "plotNOC" &&
        (selectTypeOfNOCRequired == "tenantOut" ||
          selectTypeOfNOCRequired == "arra") && (
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setOutsideNOCFormFields((prevState) => ({
                ...prevState,
                parcelId: values.parcelNumber,
                flatNumber: values.flateNumber,
                floorNumber: values.floorNumber,
                buildingName: values.buildingName,
                personIDType: values.personIdType,
                personIDNumber: values.emirate,
                customerName: values.tenantName,
                emailAddress: values.email,
                mobilePhoneNumber: values.mobile,
                propertyType: values.propertyType,
                project: values.project??"",
              }));
              setTimeout(() => {
                // alert(JSON.stringify(values, null, 2));
                if (isOrderExist) {
                  setFewaValue(
                    fewaRef.current?.checked ? fewaRef.current?.checked : false
                  );
                  // resetValidations()
                  handleContinueARRATenant(values);
                }
                setSubmitting(false);
              }, 400);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              /* and other goodies */
            }) => (
              <form onSubmit={handleSubmit}>
                <TabContainer
                  className="OutsideOwnerNoc"
                  style={{
                    display: General?.isLargeScreen ? "grid" : "flex",
                    flexDirection: General?.isLargeScreen ? "row" : "column",
                  }}
                >
                <>
                <Label
                      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        gap: "0.3rem",
                        width: General?.isLargeScreen ? "" : "98%",
                      }}
                    >
                      {selectTypeOfNOCRequired === "tenantOut"
                        ? General?.codeLabels["cm_tenantname"]?.label 
                          : General?.codeLabels["cm_ownername"]?.label
                      }
                      *{" "}
                      <Field
                        className="blueInput"
                        type="text"
                        placeholder={
                          General?.codeLabels["cm_type_here"]?.label
                            ? General?.codeLabels["cm_type_here"]?.label
                            : "Type Here"
                        }
                        style={{
                          background: "#edf4f6",
                          paddingLeft: "15px",
                        }}
                        name="tenantName"
                      />
                      {errors?.tenantName && (
                        <div style={{ height: "0.5rem" }}>
                          <ErrorMessage
                            name="tenantName"
                            component="div"
                            className="error-message"
                          />
                        </div>
                      )}
                    </Label>
                   
                    <Label
                      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        gap: "0.3rem",
                        width: General?.isLargeScreen ? "" : "98%",
                      }}
                    >
                      {General?.codeLabels["cm_mob_proptype"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_mob_proptype"]?.label
                        : "Property Type"}
                      *{" "}
                      <Field
                        as="select"
                        style={{ paddingLeft: "15px", color: "#101E8E" }}
                        // value={outsideNOCFormFields.propertyType}
                        // onChange={handlePropertyTypeChange}
                      name="propertyType"
                      disabled={outsideNetworkExtraFields}
                      >
                        <option
                          style={{
                            fontSize: `${General.accessibility.fontSize}rem`,
                          }}
                          value=""
                          disabled
                          selected
                        >
                          {General?.codeLabels["cm_mob_select"]?.label !==
                          undefined
                            ? General?.codeLabels["cm_mob_select"]?.label
                            : "Select"}
                        </option>
                        {propertyTypeValues.map((personId) => (
                          <option
                            style={{
                              fontSize: `${General.accessibility.fontSize}rem`,
                            }}
                            value={personId.key}
                          >
                            {personId.value}
                          </option>
                        ))}
                      </Field>
                      {errors?.propertyType && (
                        <div style={{ height: "0.5rem" }}>
                          <ErrorMessage
                            name="propertyType"
                            component="div"
                            className="error-message"
                          />
                        </div>
                      )}
                    </Label>
                  <Label
                      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        gap: "0.3rem",
                        width: General?.isLargeScreen ? "" : "98%",
                      }}
                    >
                      {General?.codeLabels["cm_nocemailaddress"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_nocemailaddress"]?.label
                        : "Email Address"}
                      *{" "}
                      <Field
                        className="blueInput"
                        type="email"
                        placeholder={
                          General?.codeLabels["cm_type_here"]?.label
                            ? General?.codeLabels["cm_type_here"]?.label
                            : "Type Here"
                        }
                        style={{
                          background: "#edf4f6",
                          paddingLeft: "15px",
                        }}
                        // value={outsideNOCFormFields.emailAddress}
                        name="email"
                        // onChange={(e:any) => {
                        //   setOutsideNOCFormFields({
                        //     ...outsideNOCFormFields,
                        //     emailAddress: e.target.value.toString(),
                        //   });
                        // }}
                      />
                      {errors?.email && touched?.email && (
                        <div style={{ height: "0.5rem" }}>
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="error-message"
                          />
                        </div>
                      )}
                  </Label>
                  <Label
                      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        gap: "0.3rem",
                        width: General?.isLargeScreen ? "" : "98%",
                      }}
                    >
                      {General?.codeLabels["cm_mobilenumberlabel"]?.label}
                      <Field
                        className="blueInput"
                        type="tel"
                        placeholder={
                          General?.codeLabels["cm_mobilenumberlabel"]?.label
                        }
                        style={{
                          background: "#edf4f6",
                          paddingLeft: "15px",
                        }}
                        // value={outsideNOCFormFields.mobilePhoneNumber}
                        name="mobile"
                        // onChange={(e:any) => {
                        //   setOutsideNOCFormFields({
                        //     ...outsideNOCFormFields,
                        //     mobilePhoneNumber: e.target.value.toString(),
                        //   });
                        // }}
                      />
                      {errors?.mobile && (
                        <div style={{ height: "0.5rem" }}>
                          <ErrorMessage
                            name="mobile"
                            component="div"
                            className="error-message"
                          />
                        </div>
                      )}
                  </Label>
                  {selectTypeOfNOCRequired === "arra" && (
                    <Label
                    style={{
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      gap: "0.3rem",
                      width: General?.isLargeScreen ? "" : "98%"
                    }}
                  >
                    {General?.codeLabels["cm_nocprojectname"]?.label !==
                      undefined
                      ? General?.codeLabels["cm_nocprojectname"]?.label
                      : "Project Name"}
                    *{" "}
                    <Field
                      className="blueInput"
                      type="text"
                      placeholder={General?.codeLabels["cm_type_here"]?.label ? General?.codeLabels["cm_type_here"]?.label : 'Type Here'}
                      style={{
                        background: "#edf4f6",
                        paddingLeft: "15px",
                      }}
                      // value={outsideNOCFormFields.customerName}
                      name="project"
                    />
                    {errors?.project && <div style={{ height: "0.5rem" }}>
                      <ErrorMessage
                        name="project"
                        component="div"
                        className="error-message"
                      />
                    </div>}
                  </Label>
                  )}
                   
                   <Label
                      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        gap: "0.3rem",
                        width: General?.isLargeScreen ? "" : "98%",
                      }}
                      className="InsideNocText"
                    >
                      {General?.codeLabels["cm_parcelnumber"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_parcelnumber"]?.label
                        : "Parcel Number"}
                      *{" "}
                      <Field
                        className="blueInput"
                        type="number"
                        name="parcelNumber"
                        innerRef={parcelIdRef}
                        placeholder={
                          General?.codeLabels["cm_type_here"]?.label
                            ? General?.codeLabels["cm_type_here"]?.label
                            : "Type Here"
                        }
                        style={{ background: "#edf4f6", paddingLeft: "15px" }}
                        // value={outsideNOCFormFields.parcelId}
                        readOnly={outsideNetworkExtraFields}
                        onBlur={(e: any) => {
                          if (e.target?.value.length > 8) {
                            validateParcel(e.target.value.toString());
                          }
                          // console.log(errors, "tt_");
                        }}
                      />
                      <div style={{ height: "0.5rem" }}>
                        {errors.parcelNumber && errors.parcelNumber && (
                          <div style={{ color: "red" }}>
                            {errors.parcelNumber}
                          </div>
                        )}
                      </div>
                    </Label>
                    <Label
                      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        gap: "0.3rem",
                        width: General?.isLargeScreen ? "" : "98%",
                      }}
                    >
                      {General?.codeLabels["cm_onocfloorno"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_onocfloorno"]?.label
                        : "Floor Number"}
                      *{" "}
                      <Field
                        className="blueInput"
                        type="text"
                        placeholder={
                          General?.codeLabels["cm_type_here"]?.label
                            ? General?.codeLabels["cm_type_here"]?.label
                            : "Type Here"
                        }
                        name="floorNumber"
                        innerRef={floorNumberRef}
                        readOnly={outsideNetworkExtraFields}
                        style={{
                          background: "#edf4f6",
                          paddingLeft: "15px",
                          color: "#101E8E",
                        }}
                        // value={outsideNOCFormFields.floorNumber}
                        // onChange={(e:any) => {
                        //   setOutsideNOCFormFields({
                        //     ...outsideNOCFormFields,
                        //     floorNumber: e.target.value.toString(),
                        //   });
                        // }}
                      />
                      <div style={{ height: "0.5rem" }}>
                        <ErrorMessage
                          name="floorNumber"
                          component="div"
                          className="error-message"
                        />
                      </div>
                    </Label>
                    <Label
                      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        gap: "0.3rem",
                        width: General?.isLargeScreen ? "" : "98%",
                      }}
                    >
                      {General?.codeLabels["cm_buldg_nm"]?.label !== undefined
                        ? General?.codeLabels["cm_buldg_nm"]?.label
                        : "Building Name"}
                      *
                      <Field
                        className="blueInput"
                        type="text"
                        placeholder={
                          General?.codeLabels["cm_type_here"]?.label
                            ? General?.codeLabels["cm_type_here"]?.label
                            : "Type Here"
                        }
                        innerRef={buildingNameRef}
                        readOnly={outsideNetworkExtraFields}
                        name="buildingName"
                        style={{
                          background: "#edf4f6",
                          paddingLeft: "15px",
                          color: "#101E8E",
                        }}
                      />
                      <div style={{ height: "0.5rem" }}>
                        <ErrorMessage
                          name="buildingName"
                          component="div"
                          className="error-message"
                        />
                      </div>
                  </Label>
                    <Label
                      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        gap: "0.3rem",
                        width: General?.isLargeScreen ? "" : "98%",
                      }}
                    >
                      {General?.codeLabels["cm_nocflatshopnumber"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_nocflatshopnumber"]?.label
                        : "Flat/Shop Number"}
                      *{" "}
                          <Field
                          className="blueInput"
                          type="number"
                          name="flateNumber"
                          innerRef={flatNumberRef}
                          placeholder={
                            General?.codeLabels["cm_type_here"]?.label
                            ? General?.codeLabels["cm_type_here"]?.label
                            : "Type Here"
                          }
                          style={{
                            background:!values.propertyType
                                  ? "#D3D3D3"
                                  : "#edf4f6",
                            paddingLeft: "15px",
                          }}
                          disabled={!values.propertyType}
                        // value={outsideNOCFormFields.flatNumber}
                        readOnly={outsideNetworkExtraFields}
                        // onChange={(e:any) => {
                        //   setOutsideNOCFormFields({
                        //     ...outsideNOCFormFields,
                        //     flatNumber: e.target.value.toString(),
                        //   });
                        // }}
                      />
                      <div style={{ height: "0.5rem" }}>
                        <ErrorMessage
                          name="flateNumber"
                          component="div"
                          className="error-message"
                        />
                      </div>
                  </Label>
                    <Label
                      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        gap: "0.3rem",
                        width: General?.isLargeScreen ? "" : "98%",
                      }}
                    >
                      {General?.codeLabels["cm_onocpersonidtype"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_onocpersonidtype"]?.label
                        : "Person ID Type"}
                      *{" "}
                      <Field
                        as="select"
                        style={{ paddingLeft: "15px", color: "#101E8E" }}
                        // value={outsideNOCFormFields.personIDType}
                        // onChange={handlePersonIdTypeChange}
                        disabled={outsideNetworkExtraFields}
                        innerRef={personIDTypeRef}
                        name="personIdType"
                        className="SocialCaseSelect"
                      >
                        <option
                          style={{
                            fontSize: `${General.accessibility.fontSize}rem`,
                          }}
                          value=""
                          disabled
                          selected
                          hidden
                        >
                          {General?.codeLabels["cm_mob_select"]?.label !==
                          undefined
                            ? General?.codeLabels["cm_mob_select"]?.label
                            : "Select"}
                        </option>
                        {personIdValues.map((personId) => (
                          <option
                            style={{
                              fontSize: `${General.accessibility.fontSize}rem`,
                            }}
                            value={personId.key}
                          >
                            {personId.value}
                          </option>
                        ))}
                      </Field>
                      <div style={{ height: "0.5rem" }}>
                        <ErrorMessage
                          name="personIdType"
                          component="div"
                          className="error-message"
                        />
                      </div>
                    </Label>
                    <Label
                      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        gap: "0.3rem",
                        width: General?.isLargeScreen ? "" : "98%",
                      }}
                    >
                      {General?.codeLabels["cm_onocpersonidno"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_onocpersonidno"]?.label
                        : "ID Number"}
                      *{" "}
                      <Field
                        className="blueInput"
                        type="number"
                        placeholder={
                          General?.codeLabels["cm_type_here"]?.label
                            ? General?.codeLabels["cm_type_here"]?.label
                            : "Type Here"
                        }
                        innerRef={personIDNumberRef}
                        style={{ background: "#edf4f6", paddingLeft: "15px" }}
                        // value={outsideNOCFormFields.personIDNumber}
                        readOnly={outsideNetworkExtraFields}
                        name="emirate"
                        // onChange={(e:any) => {
                        //   setOutsideNOCFormFields({
                        //     ...outsideNOCFormFields,
                        //     personIDNumber: e.target.value.toString(),
                        //   });
                        // }}
                      />
                      <div style={{ height: "0.5rem" }}>
                        <ErrorMessage
                          name="emirate"
                          component="div"
                          className="error-message"
                        />
                      </div>
                    </Label>
                    {/* outsideNetworkExtraFields */}
                    {/* {outsideNetworkExtraFields && (
                      <> */}
                   {selectTypeOfNOCRequired !== 'tenantOut' && <Label></Label>}
                    {outsideNetworkExtraFields && (
                      <Label
                        style={{
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "",
                          fontFamily: "Segoe UI",
                          fontStyle: "normal",
                          fontWeight: "700",
                          fontSize: `${General.accessibility.fontSize}rem`,
                          lineHeight: "16px",
                          gap: "0.5rem",
                        }}
                      >
                        {General?.codeLabels["cm_nocmandatoryattachments"]
                          ?.label !== undefined
                          ? General?.codeLabels["cm_nocmandatoryattachments"]
                              ?.label
                          : "Required Documents"}
                        *
                      </Label>
                    )}

                  <Label></Label>

                  {outsideNetworkExtraFields ?
                  selectTypeOfNOCRequired !== 'arra'  ? mandatoryDocumentsForTenant.map((doc: any) => (
                        <Label
                          style={{
                            color: contrast?.contrastColor
                              ? contrast?.contrastColor
                              : "",
                            fontFamily: "Segoe UI",
                            fontStyle: "normal",
                            fontWeight: "700",
                            fontSize: `${General.accessibility.fontSize}rem`,
                            lineHeight: "16px",
                            gap: "0.5rem",
                          }}
                        >
                          <div style={{ width: "100%" }} key={doc.key}>
                            <Document
                              exists={uploadedFiles[doc.key] !== undefined}
                              mainText={doc.label}
                              subText={
                                General?.codeLabels["cm_mandatory_document"]
                                  ?.label
                              }
                              onChange={(e) => handleFileEvent(e, doc.key)}
                              inputName={doc.key}
                            />
                            {validationErrors[doc.key] && (
                              <p
                                style={{
                                  color: "red",
                                  margin: "4px 0 0 0",
                                  fontWeight: "bold",
                                }}
                              >
                                {General?.codeLabels["cm_nofileerr"]?.label
                                  ? General?.codeLabels["cm_nofileerr"]?.label
                                  : "Please uploadType Here"}{" "}
                                {doc.label}
                              </p>
                            )}
                          </div>
                        </Label>
                      ))  
                      
                      : mandatoryDocuments.map((doc: any) => (
                        <Label
                          style={{
                            color: contrast?.contrastColor
                              ? contrast?.contrastColor
                              : "",
                            fontFamily: "Segoe UI",
                            fontStyle: "normal",
                            fontWeight: "700",
                            fontSize: `${General.accessibility.fontSize}rem`,
                            lineHeight: "16px",
                            gap: "0.5rem",
                          }}
                        >
                          <div style={{ width: "100%" }} key={doc.key}>
                            <Document
                              exists={uploadedFiles[doc.key] !== undefined}
                              mainText={doc.label}
                              subText={
                                General?.codeLabels["cm_mandatory_document"]
                                  ?.label
                              }
                              onChange={(e) => handleFileEvent(e, doc.key)}
                              inputName={doc.key}
                            />
                            {validationErrors[doc.key] && (
                              <p
                                style={{
                                  color: "red",
                                  margin: "4px 0 0 0",
                                  fontWeight: "bold",
                                }}
                              >
                                {General?.codeLabels["cm_nofileerr"]?.label
                                  ? General?.codeLabels["cm_nofileerr"]?.label
                                  : "Please uploadType Here"}{" "}
                                {doc.label}
                              </p>
                            )}
                          </div>
                        </Label>
                      ))  
                      
                      
                    :
                    <></>
                  }

                {selectTypeOfNOCRequired !== "tenantOut" && <Label></Label>}

                    {outsideNetworkExtraFields && (
                    
                         <div
                         style={{
                           border: `1px solid ${ contrast?.contrastBackground
                             ? contrast?.contrastBackground
                             : ""}`,
                           textAlign: "center",
                           cursor: "pointer",
                           display: "inline-block",
                           height: "25px",
                           fontFamily: "Segoe UI",
                           fontStyle: "normal",
                           fontWeight: "700",
                           fontSize: "14px",
                           lineHeight: "20px",
                           textTransform: "uppercase",
                           background: contrast?.contrastColor
                             ? contrast?.contrastColor
                             : "",
                           color: contrast?.contrastBackground
                             ? contrast?.contrastBackground
                             : "",
                           width: General?.isLargeScreen ? "210px" : "100%",
                         }}
                         onClick={handleAddOptionalDocument}
                       >
                         {General?.codeLabels["cm_add_attachment"]?.label !==
                         undefined
                           ? General?.codeLabels["cm_add_attachment"]?.label
                           : "Add Document"}
                       </div>
                    )}
                    <Label></Label>

                    {optionalUploadedFiles.map((optionalFile: OptionalFile) => (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <Document
                            exists={false}
                            mainText={optionalFile.name}
                            subText={
                              General?.codeLabels["cm_optional_document"]
                                ?.label !== undefined
                                ? General?.codeLabels["cm_optional_document"]
                                    ?.label
                                : "Optional Document"
                            }
                            onChange={(e) =>
                              handleFileEvent(e, optionalFile.id)
                            }
                            inputName={optionalFile.name}
                            removeButton={
                              <button
                                type="button"
                                style={{
                                  cursor: "pointer",
                                  background: "none",
                                  border: 0,
                                  marginRight: "20px",
                                }}
                                onClick={() => handleRemoveOptionalDocument(optionalFile.id)}
                              >
                                <img src={trashIcon} alt="Remove Optional Attachment" />
                              </button>
                            }
                         
                          />
                        </div>
                        {/* <div>
                          <button
                            type="button"
                            style={{
                              cursor: "pointer",
                              background: "none",
                              border: 0,
                            }}
                            onClick={() =>
                              handleRemoveOptionalDocument(optionalFile.id)
                            }
                          >
                            <img
                              src={trashIcon}
                              alt="Remove Optional Attachment"
                            />
                          </button>
                        </div> */}
                      </div>
                    ))}
                    {/* // </> */}
                    {/* )} */}
                    <hr
                      style={{
                        gridColumn: "1 / span 2",
                        width: "100%",
                        border: "1px solid #B6BFDC;",
                      }}
                  />
                 
                  {outsideNetworkExtraFields && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                     <div
                     style={{
                       display: "flex",
                       flexDirection: "column",
                       gap: "0.5rem",
                          marginBottom: "",
                          
                          width: "100%",
                       position: "relative",
                     }}
                   >
                       <div
                       style={{
                         display: "flex",
                         alignItems: "flex-start", // Changed from center to flex-start
                            gap: "0.5rem",
                            position: "absolute",
                         width:"1000px"
                       }}
                       >
                       <Field
                         style={{ 
                        //  width: "20px", 
                         height: "20px",
                         marginTop: "3px" // Added marginTop to align with text
                         }}
                         name="toggle"
                         type="checkbox"
                       />
                         <label
                         style={{
                         fontFamily: "Segoe UI",
                         fontStyle: "normal",
                         fontWeight: "400",
                         fontSize: `${General.accessibility.fontSize}rem`,
                         lineHeight: "20px",
                         paddingTop:"2px",
                         color: General.contrast.contrastColor
                           ? General.contrast.contrastColor
                           : General?.ColorAss,
                            }}
                            
                         >
                            <span style={{letterSpacing:"-0.5px"}} dangerouslySetInnerHTML={{
                         __html: (General?.codeLabels["cm_user_consent_msg"]?.label !== undefined
                           ? General?.codeLabels["cm_user_consent_msg"]?.label 
                           : "I accept all")
                         }} />
                         </label>
                       </div>
                     {/* <hr style={{ width: "100%" }} /> */}
                     </div>
                        <ButtonSecondary
                        style={{
                          color: contrast?.contrastBackground
                          ? contrast?.contrastBackground
                          : "#fff",
                          background: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "#101E8E",
                          width: General?.isLargeScreen ? "60%" : "98%",
                          padding: "10px 0",
                          fontSize: `${General.accessibility.fontSize}rem`,
                          opacity: (!values.toggle || !isParcelValid) ? "0.5" : "1",
                          marginTop:"3rem"
                        }}
                        disabled={!isParcelValid || !values.toggle}
                        type="submit"
                        className={General.colorClass}
                        >
                        {continueLoader ? (
                          <Spinner width="30px" height="30px" />
                        ) : isOrderExist ? (
                          General?.codeLabels["cm_submit"]?.label
                        ) : General?.codeLabels["cm_submit"]?.label !==
                          undefined ? (
                          General?.codeLabels["cm_submit"]?.label
                        ) : (
                          "Submit"
                        )}
                      </ButtonSecondary>
                    </div>
                    )}
                    {!outsideNetworkExtraFields && (
                      <ButtonSecondary
                        style={{
                          color: contrast?.contrastBackground
                            ? contrast?.contrastBackground
                            : "#fff",
                          background: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "#101E8E",
                          width: General?.isLargeScreen ? "60%" : "98%",
                          padding: "10px 0",
                          fontSize: `${General.accessibility.fontSize}rem`,
                          opacity: !isParcelValid ? "0.5" : "1",
                        }}
                        disabled={!isParcelValid}
                        onClick={() => {
                          if (isEmpty(errors)) validateId();
                        }}
                        // type="submit"
                        className={`${General?.colorClass} InsideNocButton`}
                      >
                        {continueLoader ? (
                          <Spinner width="30px" height="30px" />
                        ) : isOrderExist ? (
                          General?.codeLabels["cm_btncontinue"]?.label
                        ) : General?.codeLabels["cm_btncontinue"]?.label !==
                          undefined ? (
                          General?.codeLabels["cm_btncontinue"]?.label
                        ) : (
                          "CONTINUE"
                        )}
                      </ButtonSecondary>
                    )}
                  </>
                </TabContainer>
              </form>
            )}
          </Formik>
        )}
      <TabContainer>
        {/* <Error id={"postNocDueError"} /> */}
        {/* <Error id={"validateOutOfNetworkNOCError"} /> */}
        {/* <Error id={"validateOutOfNetworkNOCError"} />  */}
        <Modal
          open={showInsideModal}
          onClose={() => setInsideModal(false)}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <InsideModal closeModal={() => setInsideModal(false)} />
        </Modal>
      </TabContainer>
    </>
  );
};

export default ApplyPropertyDetails;
